<template>
    <div class="page-container" :class="{'has-breadcrumb': profile.isSharpAdmin()}">
        <div class="px-8 md:px-5 py-5 " v-if="profile.isSharpAdmin()">
            <breadcrumb></breadcrumb>
        </div>
        <div class="px-8 md:px-5 py-5 ">
            <h1 class="mb-6">
                Users
            </h1>
            <user-grid
                    title="Select a machine to log the Job against:"
            ></user-grid>
        </div>
    </div>
</template>

<script charset="utf-8">
    import Vuex from 'vuex';
    import UserGrid from './includes/UserGrid.vue';
    import Breadcrumb from './includes/Breadcrumb.vue';

    export default {
        name: 'ClientsUser',

        components: {
            UserGrid,
            Breadcrumb
        },

        created: function () {
            let params = this.$router.currentRoute.value.params;
            this.getClient({ clientID: params.clientID}).then(data => {
                this.setPaths([
                    {
                        text: 'Sharp Admin',
                        name: 'adminClients'
                    },
                    {
                        text: data.name,
                        name: 'adminUser',
                        params: { clientID: data.id }
                    },
                    {
                        text: 'Users',
                        isText: true
                    },
                ]);
            });
        },

        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),
        },

        methods: {
            ...Vuex.mapActions('accounts', {
                getClient: 'getClient'
            }),
            ...Vuex.mapMutations('layout', {
                setPaths: 'setPaths',
            })
        }


    }
</script>
